// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-custom[data-v-d6990b92]{margin:0;border-radius:1.5rem}.text-muted a[data-v-d6990b92]:not(:hover){color:#b8b8bd}.ui-dark .text-muted a[data-v-d6990b92]:not(:hover){color:#484a56}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
